import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import AccountsOverviewCard from './AccountsOverviewCard';

const AccountsOverviewPage = () => {
  const { t } = useTranslation();
  return (
    <ContentLayout>
      <PageMetatags title={t('account:status.accounts.label')} />
      <AccountsOverviewCard />
    </ContentLayout>
  );
};
export default AccountsOverviewPage;
